import { Cookies } from "react-cookie";
//import { isDev } from "../config";

export default function log() {
  const cookies = new Cookies();
  const showlog = cookies.get("showlog");

  if (showlog) {
    console.log(...arguments);
  }
}
